const useSelectableReferences = ({
  field,
  selected,
  setSelected,
  oneTap,
  onClose,
  selectedSubitemParent,
  subitemField,
}) => {
  const isSingleRef = field?.FieldType === "SingleReference";
  const isMultiRef = field?.FieldType === "MultiReference";

  function isRecordSelected(record) {
    if (isSingleRef) {
      if (selected?._isSubitem) {
        return selected?._SubitemID === record?.id;
      }

      return (
        selected?.id === record?.id &&
        selected?._ModuleAPIName === record?._ModuleAPIName
      );
    }

    if (isMultiRef) {
      if (!selected) return false;
      return !!selected?.find?.((val) => {
        if (val?._isSubitem) {
          return val?._SubitemID === record?.id;
        }

        return (
          val.id === record.id && val._ModuleAPIName === record._ModuleAPIName
        );
      });
    }

    return false;
  }

  function handleSelectRecord(record) {
    if (isSingleRef) {
      if (selectedSubitemParent) {
        if (selected?._SubitemID === record?.id) {
          setSelected(null);
        } else {
          setSelected(getSubitemPayload(record));
        }
      } else {
        if (selected?.id === record?.id) {
          setSelected(null);
        } else {
          setSelected(record);
        }
      }
    }

    if (isMultiRef) {
      if (
        selected &&
        !!selected?.find?.((val) => {
          if (val?._isSubitem) {
            return val?._SubitemID === record.id;
          }

          return val.id === record.id;
        })
      ) {
        setSelected((prev) =>
          prev.filter((r) => {
            if (r?._isSubitem) {
              return r?._SubitemID !== record.id;
            }

            return r.id !== record.id;
          })
        );
      } else {
        const payload = selectedSubitemParent
          ? getSubitemPayload(record)
          : record;

        setSelected((prev) => {
          return prev && prev?.length ? [...prev, payload] : [payload];
        });
      }
    }

    if (oneTap) {
      onClose();
    }
  }

  function getSubitemPayload(subitem) {
    const payload = {
      id: selectedSubitemParent?.id,
      ModuleAPIName: subitem?._ModuleAPIName,
      _ModuleAPIName: subitem?._ModuleAPIName,
      _isSubitem: true,
      _SubitemFieldAPIName: subitem?._SubitemParentAPIName,
      _SubitemID: subitem?.id,
    };

    const recordNameField = subitemField.SubitemRecordNameField;

    if (recordNameField && subitem?.[recordNameField]) {
      payload[recordNameField] = subitem[recordNameField];
    }

    return payload;
  }

  return { isRecordSelected, handleSelectRecord };
};

export default useSelectableReferences;
